import { writable } from "svelte/store";

export const store = writable({
  options: [],
  posts: [],
  groupedPosts: [],
  pagination: {
    before: [],
    after: [],
  },
});
/*
export const options = writable({});

export const posts = writable({})
export const groupedPosts = writable({})
*/
